// extracted by mini-css-extract-plugin
export var labelWrapper = "_c5-0";